import request from './request'

// 反馈类型
export type FeedbackType = 1 | 2 | 3 | 4

export const FeedbackTypeMap: Record<FeedbackType, string> = {
  1: 'BUG反馈',
  2: '功能建议',
  3: '内容纠错',
  4: '其他'
}

// 反馈状态
export type FeedbackStatus = 1 | 2 | 3 | 4

export const FeedbackStatusMap: Record<FeedbackStatus, string> = {
  1: '待处理',
  2: '处理中',
  3: '已回复',
  4: '已关闭'
}

// 反馈项
export interface Feedback {
  id: string
  type: FeedbackType
  type_text: string
  title: string
  content: string
  contact?: string
  status: FeedbackStatus
  status_text: string
  reply?: string
  replied_at?: string
  screenshots?: string[]
  created_at: string
}

// 提交反馈请求
export interface SubmitFeedbackRequest {
  type: FeedbackType
  title: string
  content: string
  contact?: string
  screenshots: string[]
}

// 提交反馈响应
export interface SubmitFeedbackResponse {
  id: string
}

// 获取反馈列表请求
export interface GetFeedbackListRequest {
  page?: number
  page_size?: number
}

// 获取反馈列表响应
export interface GetFeedbackListResponse {
  list: Feedback[]
  total: number
  page: number
  page_size: number
}

/**
 * 提交反馈
 */
export function submitFeedback(data: SubmitFeedbackRequest) {
  return request.post<SubmitFeedbackResponse>('/feedback', data)
}

/**
 * 获取我的反馈列表
 */
export function getMyFeedbackList(params: GetFeedbackListRequest = {}) {
  return request.get<GetFeedbackListResponse>('/feedback/list', { params })
}

/**
 * 获取反馈详情
 */
export function getFeedbackDetail(id: string) {
  return request.get<{ feedback: Feedback }>(`/feedback/${id}`)
}

/**
 * 评价反馈
 */
export function rateFeedback(id: string, satisfaction: number, comment?: string) {
  return request.post<{ success: boolean }>('/feedback/rate', {
    id,
    satisfaction,
    comment
  })
}
